export enum PhoneMode {
  Dialpad = 0,
  Search = 1,
}
